import { useDispatch } from 'react-redux';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIButton from 'UIComponents/button/UIButton';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { ANALYZE_OPT_IN } from '../../../constants/Events';
import Links from '../../../constants/Links';
import { trackClickAnalyzeOptInConfirm, trackClickKBLink, tracker } from '../../../utils/usageTracker';
import { enableAIProjectionsOptIn } from '../../../actions/AnalyzeActions';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_BETA_TERMS_URL = 'https://legal.hubspot.com/hubspot-beta-terms';
const AnalyzeOptInModal = ({
  onClickClose
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 580,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "analyze.optIn.modal.title"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClickClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "analyze.optIn.modal.body"
        }), /*#__PURE__*/_jsx(Illustration, {
          marginBlockStart: "300",
          marginBlockEnd: "300",
          name: "forecasting-ai",
          width: 150
        }), /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.optIn.modal.question"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "600",
        as: "div",
        children: [/*#__PURE__*/_jsx(AIButton, {
          onClick: () => {
            trackClickAnalyzeOptInConfirm();
            dispatch(enableAIProjectionsOptIn()).catch(() => {
              // should be caught in enableAIProjectionsOptIn
            });
          },
          usageTracker: tracker,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.optIn.modal.button.primary"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onClickClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "analyze.optIn.modal.button.secondary"
          })
        })]
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "analyze.optIn.modal.terms_jsx",
        elements: {
          Link
        },
        options: {
          href: HUBSPOT_BETA_TERMS_URL
        }
      }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
        url: Links.AI_FORECAST_KB,
        onClick: () => trackClickKBLink({
          subscreen: ANALYZE_OPT_IN
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "analyze.optIn.modal.learnMore"
        })
      })]
    })]
  });
};
export default AnalyzeOptInModal;